





















export default {
    name: 'ArticleImage'

    props: ['document']

    computed:
        imageSrc: -> 
            unless @fields.image then return
            @fields.image.mittel.url
        imageSrcset: ->
            unless @fields.image then return
            @fields.image.mittel.url + ', ' + @fields.image.klein.url

    data: ->
        fields: @defaultFields()

    methods:
        defaultFields: ->
            width: 'Seite',
            image: []
            description: []

        setContent: (document) ->
            fields =
                image: document.primary.image
                description: document.primary.description
            $.extend @fields, fields
    
    created: ->
        @setContent @document
}
